import React from 'react';
import ServicePage from '../components/ServicePage';
import heroBillede from '../images/MidlertidigVejHero.jpg';

function MidlertidigVej() {
  return (
    <ServicePage
      slug="midlertidig-vej"
      path="/midlertidig-vej"
      navn="Midlertidig vej"
      seo={{
        title: 'Midlertidig vej & byggeveje på Sjælland | JBC Entreprenøren',
        description: 'Vi etablerer midlertidige veje, byggeveje og adgangsveje i Holbæk, Tølløse, Roskilde og på hele Sjælland. Hurtig etablering – få et gratis tilbud.',
        image: 'https://jbcentreprenoeren.dk/images/og-midlertidig-vej.jpg',
        serviceName: 'Midlertidige vejanlæg',
      }}
      hero={{
        titel: 'Midlertidig vej og vejanlæg',
        tekst: 'Vi etablerer midlertidige veje og adgangsveje for byggeprojekter på hele Sjælland.',
        cta: 'Få tilbud på vejanlæg',
        billede: heroBillede,
        billedeAlt: 'Midlertidig byggevej anlagt med gravemaskine',
      }}
      intro={{
        titel: 'Sikker adgang til din byggeplads',
        tekst: [
          'JBC Entreprenøren etablerer midlertidige vejanlæg i Holbæk, Tølløse, Roskilde, Jyderup og resten af Sjælland.',
          'Med lokalt kendskab til området sørger vi for, at alt bliver gjort ordentligt, så du får en pålidelig og sikker adgangsvej til dit byggeprojekt.',
        ],
      }}
      ydelser={{
        titel: 'Vores vejanlægstjenester',
        punkter: [
          'Midlertidige adgangsveje',
          'Byggeveje til konstruktion',
          'Parkeringspladser',
          'Stabilisering af undergrund',
          'Afrydning og etablering',
        ],
      }}
      fordele={{
        titel: 'Derfor vælger kunder os til vejanlæg',
        punkter: [
          'Hurtig etablering',
          'Erfaring med alle typer byggeprojekter',
          'Kvalitetsmaterialer og udstyr',
          'Fleksible løsninger',
          'Konkurrencedygtige priser',
        ],
      }}
      kontaktTekst="Skal du have etableret en midlertidig vej? Vi hjælper gerne med dit projekt."
    />
  );
}

export default MidlertidigVej;
